import { convertStateToAbbr, getSnowLoss } from 'options';
import {
  getStateSnowLoss as getStateSnowLossCore,
  buildEffectiveSystemLosses as buildEffectiveSystemLossesCore,
} from '@aerialytic/designer-states/core';

const snowLookup = {
  convertStateToAbbr,
  getSnowLoss,
};

export const getStateSnowLoss = (state) =>
  getStateSnowLossCore(state, snowLookup);

export const buildEffectiveSystemLosses = (args = {}) =>
  buildEffectiveSystemLossesCore({
    ...args,
    snowLookup,
  });
